import React, { useRef, useState, useEffect } from "react";

const SlidingTab = ({ menuArr, selectedInd, setIndex, children, sibling }) => {
    const menuRef = useRef(null);
    const [underlineStyle, setUnderlineStyle] = useState({
        width: '78px',
        offsetX: '0px'
    });

    useEffect(() => {
        if (menuRef.current) {
            const selectedMenu = menuRef.current.children[selectedInd];
            if (selectedMenu) {
                setUnderlineStyle({
                    width: `${selectedMenu.offsetWidth}px`,
                    offsetX: `${selectedMenu.offsetLeft - selectedMenu.parentNode.offsetLeft}px`
                });
            }
        }
    }, [selectedInd, menuArr]);

    const handleMenuClick = (ev, ind) => {
        setIndex(ind);
        setUnderlineStyle({
            width: `${ev.target.offsetWidth}px`,
            offsetX: `${ev.target.offsetLeft - ev.target.parentNode.offsetLeft}px`
        });
    };

    const getMenus = () => {
        return menuArr.map((menu, ind) => (
            <span key={ind}
                className={`px-2 sub-title sliding-menu-text ${selectedInd === ind ? "sliding-menu-selected" : ""}`}
                onClick={(ev) => handleMenuClick(ev, ind)}>
                {menu}
            </span>
        ));
    }

    return (
        <div className="p-2 ps-0 d-flex flex-column">
            <div className="d-flex justify-content-between">
                <div>
                    <div className="d-flex gap-1" ref={menuRef}>
                        {getMenus()}
                    </div>
                    <div className="sliding-menu" 
                         style={{
                             width: underlineStyle.width,
                             transform: `translateX(${underlineStyle.offsetX})`
                         }} />
                </div>
                {sibling}
            </div>
            <div>
                {children}
            </div>
        </div>
    );
}

export default SlidingTab; 
